import { getValueFromLocalStorage } from '../utilities/utilityFunctions';
import { client, gql } from './Client';

const areaDetailsQuery = gql`
  query areaDetails($areaId: Int!, $discipline: Int) {
    areaDetails(areaId: $areaId, discipline: $discipline) {
      areaId
      area {
        name
        pkArea
        fkParentArea
        fkAreaType
        fkSite
        fkDiscipline
        legacyArea
        legacyParentArea
        siteLayer
        isActive
        isDecommissioned
        commentDecommissioned
        pcsId
        name
        abbrv
        comment
        description
        northGridLine
        southGridLine
        eastGridLine
        westGridLine
        upperGridLine
        lowerGridLine
        assetId
        eAMId
        assetName
        assetDescription
        floorLevel
        lowBound
        upperBound
        createdBy
        modifiedBy
        dateCreated
        dateModified
        fileArea {
          pkFileArea
          fkArea
          fkFileAims
          fkDrawingType
          isReportFile
          name
          abbrv
          comment
          description
          legacyArea
          legacyFileAims
          site
          discipline
          legacyId
          createdBy
          modifiedBy
        }
        areaEnvironmentCondition {
          pkAreaEnvironmentCondition
          fkArea
          fkEnvironmentCondition
          name
          abbrv
          comment
          createdBy
          dateAssessed
          dateCreated
          dateModified
          description
          legacyArea
          siteId
          disciplineId
        }
        areaRiskResult {
          pkAreaRiskResult: fkArea
          fkAreaRiskCategoryRankType
          fkRiskAssessmentCategory
          inspector
          isActive
          name
          abbrv
          comment
          description
          riskEditErrorCategory
          legacyArea
          site
          modifiedBy
          dateAssessed
          dateCreated
          dateModified
          legacyId
        }
      }
      historyAreaRiskResult {
        areaId
        fkAreaRiskCategoryRankType
        category
        areaRiskCategoryRankTypeName
        dateAssessed
        fkRiskAssessmentCategory
        comment
        riskAssessmentCategoryName
        dateAssessed
        riskRankName
        riskRankValue
      }
      electHistoryAreaRiskResult {
        areaId
        category
        fkAreaRiskCategoryRankType
        fkRiskAssessmentCategory
        areaRiskCategoryRankTypeName
        riskAssessmentCategoryName
        riskRankName
        riskRankValue
        comment
      }
      assetMainCategoryName
      assetCategoryName
    }
  }
`;

const areaDetailsProperties = (dynamicID: number) =>
  client.query({
    query: areaDetailsQuery,
    variables: {
      areaId: dynamicID || Number(getValueFromLocalStorage('id')),
      discipline: JSON.parse(getValueFromLocalStorage('selectedDiscipline') || '{}')
        ?.selectedDisciplineId,
    },
  });

export { areaDetailsProperties };
